import React, {useCallback, useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../../../util/fonts';

import {strings} from '../../../../util/strings';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../store/actions';

import colors from '../../../../util/colors';
import {Column, Row} from '../../../../components/layout';
import Header2 from '../../../../components/headers/header2/Header2';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import {get} from '../../../../api/api';
import {uriGetProcedures} from '../../../../api/endpoints';
import AppSelectInput from './../../../../components/input/app-select-input/index';
import {
  IPreAuthorizationProcedure,
  IProcedureDetail,
} from '../../PreAuthorizations';
import RenderDocument from '../../../../components/container-document-download/RenderDocument';

const validationSchema = Yup.object().shape({
  proceed: Yup.string().required(),
});

export interface PreAuthorizationProcedureProps {
  wizard: any;
  setWizard(value: any): void;
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  language: any;
  labels: typeof strings.pt.preAuthorizations;
  addToWizard(value: any): void;
  buStyles: any;
  accessToken: any;
}

function PreAuthorizationProcedure({
  user,
  selectedBu,
  language,
  labels,
  buStyles,
  accessToken,
}: PreAuthorizationProcedureProps) {
  const [proceed, setProceed] = useState<any>();
  const [proceedOptions, setProceedOptions] = useState<
    IPreAuthorizationProcedure[]
  >([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [possibleValues, setPossibleValues] = useState<any[]>([]);
  const [fetchAgain, setFetchAgain] = useState<number>(0);

  const featureName = 'PreAuthorizationProcedure';

  useEffect(() => {
    async function getProceedOptions() {
      const proceeds: any = await get(
        uriGetProcedures(selectedBu.buId),
        false,
        0,
        featureName
      );
      const activeProceeds = proceeds?.data?.items.filter(
        (procedure: IPreAuthorizationProcedure) => procedure.status === 'ACTIVE'
      );

      setProceedOptions(activeProceeds);

      let options: any[] = [];
      activeProceeds?.forEach((activeProceed: IPreAuthorizationProcedure) => {
        const detailAux = activeProceed.buPreAuthProcedureDetails.find(
          (detail: IProcedureDetail) => detail.languageAlias === language
        );
        if (detailAux && detailAux.frontendTitle) {
          options.push({
            label: detailAux.frontendTitle,
            value: detailAux.serviceGroup,
          });
        }
      });

      setPossibleValues(options);
    }
    getProceedOptions();
  }, []);

  useEffect(() => {
    setProceed(proceed);
  }, [proceed]);

  const fetchFile = useCallback(
    async (source: string) => {
      if (
        source.includes('BOnull') ||
        source.includes('BOundefined') ||
        source.includes('object%20Object')
      ) {
        return;
      }
      const localStorageUser = JSON.parse(
        localStorage?.getItem('user') as string
      );

      const access_token =
        localStorage?.getItem('access_token') ||
        localStorageUser?.access_token ||
        accessToken;
      if (access_token && fetchAgain < 2) {
        try {
          const response = await fetch(source, {
            headers: {
              Authorization: 'Bearer ' + access_token,
              X_MYADV_API_KEY: process.env.REACT_APP_DEFAULT_TENANT_ALIAS || '',
            },
          });

          if (response.status === 404 || response.status === 401) {
            setFetchAgain(fetchAgain + 1);
          } else {
            //return response;
            await response.blob().then((blobResponse) => {
              const urlCreator = window.URL || window.webkitURL;
              const a = document.createElement('a');
              a.href = urlCreator.createObjectURL(blobResponse);
              a.download = 'file';
              document.body.appendChild(a);
              a.click();
              a.remove();
            });
          }
        } catch (error) {
          console.log('Error fetching image:', error);
        }
      } else {
        return '';
      }
    },
    [fetchAgain]
  );

  const getProceedWithValue = (value: any) => {
    const selectedProceed = proceedOptions.find(
      (proceed: IPreAuthorizationProcedure) =>
        proceed.buPreAuthProcedureDetails.find(
          (detail: IProcedureDetail) => detail.languageAlias === language
        )?.serviceGroup === value
    );

    if (selectedProceed) {
      const detail = selectedProceed.buPreAuthProcedureDetails.find(
        (detail: IProcedureDetail) => detail.languageAlias === language
      );
      let urlAux = `${process.env.REACT_APP_BASE_BACKOFFICE_IMAGES_URL_PUBLIC}${detail?.file}`;
      setSelectedOption({
        label: detail?.frontendTitle,
        value: detail?.serviceGroup,
      });
      return {
        id: selectedProceed.id,
        name: selectedProceed.title,
        url: urlAux,
        description: detail?.fileDescription,
      };
    }
  };

  return (
    <>
      <Column className="pre-authorization-main-column">
        <Column className="pre-authorization-container">
          <Column>
            <Row className="pre-authorization-header-row">
              <Header2
                className="pre-authorization-header"
                style={{
                  ...fonts.XL,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {labels?.authorization_requestOfPreAuthorization}
              </Header2>
            </Row>

            <Row className="response-in-72h">
              <p className="m-0" style={{...fonts.M, color: colors.black}}>
                {labels?.authorization_responseIn72hours}
              </p>
            </Row>
            <Row className="justify-content-center">
              <p
                className="select-type-of-documents m-0"
                style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
                {labels?.authorization_chooseTypeOfDocuments}
              </p>
            </Row>
            <Row className="pre-authorization-dropdown-row">
              <AppSelectInput
                value={selectedOption?.value || ''}
                className="pre-authorization-dropdown"
                onChange={(value: any) => {
                  setProceed(getProceedWithValue(value));
                }}
                options={possibleValues}
              />
            </Row>

            <Column className="justify-content-center mb-2 container-document">
              {proceed !== undefined && (
                <>
                  <Row
                    className="reimbursement-success-file-title-row-doc-download m-0"
                    style={{...fonts.MM, color: colors.black}}>
                    {labels?.authorization_availableDocuments}
                  </Row>
                  <Row className="render-document">
                    <RenderDocument
                      isIrsDeclaration={false}
                      documentDownload={() => fetchFile(proceed.url)}
                      item={proceed}
                    />
                  </Row>
                </>
              )}
            </Column>

            {proceed !== undefined ? (
              <Column>
                <Row className="justify-content-center">
                  <Icon
                    name={Icons.ALERT_PROBLEM}
                    width={'26'}
                    height={'26'}
                    changeViewbox
                    viewBox={'0 0 24 24'}
                    fill={colors.alertRed}
                  />
                </Row>
                <Row className="justify-content-center m-0">
                  <p
                    style={{
                      ...fonts.MM,
                      ...fonts.Medium,
                      color: colors.alertRed,
                    }}>
                    {labels?.authorization_impressForm}
                  </p>
                </Row>
                <Row className="justify-content-center">
                  <p
                    style={{
                      ...fonts.MM,
                      ...fonts.Light,
                      color: colors.black,
                    }}>
                    {labels?.authorization_caseOfAcident}
                  </p>
                </Row>
              </Column>
            ) : (
              <div></div>
            )}
            <Link
              onClick={() => {
                setWizard({});
              }}
              to="/pre-autorizacoes"
              className="pre-authorization-header-content-exit-label"
              style={{
                ...fonts.SM,
                ...fonts.SemiBold,
                color: buStyles?.primaryColor || colors.fluorescentBlue,
              }}>
              {labels?.authorization_leaveRequest}
              <Icon
                className="svg-close-button inline-svg-close-button"
                name={Icons.CLOSE}
                width={'12'}
                height={'12'}
                changeViewbox={true}
                strokeWidth={'0.5'}
              />
            </Link>
          </Column>
        </Column>
      </Column>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  language,
  user,
  strings,
  wizard,
  globalStyles,
  accessToken,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  language: language.value,
  labels: strings.value.pt.preAuthorizations,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  accessToken: accessToken.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PreAuthorizationProcedure)
);
